import { createModalStore } from '@/shared/lib/modal';

export const useProjectTypeModalStore = createModalStore();
